<form id="{{formId()}}" #form="ngForm" class="form-validate">
  <app-register-forms [data]="data()"
                      [request]="request()"
                      (showDocumentSignPanel)="onShowDocumentSignPanelChange($event)"></app-register-forms>
  @if (showRegisterPanel()) {
    <app-register-form-violation></app-register-form-violation>
    @if (showDocumentSignPanel()) {
      <app-document-sign (onSubmit)="submitForm()"
                         [formValid]="formValid()"
                         (onSelectSignType)="validForm($event)"
                         [request]="request()"></app-document-sign>
    }
  }
</form>
